import React from 'react';
import card2 from '../../../assets/images/tarotcards/tarot-card-2.jpg'
import { Link } from 'react-router-dom';
import { sendData } from '../../../../analytics/sendData';
import { FormattedMessage } from 'react-intl';

class Card2 extends React.Component{
    state = {
        showOpenCookie: false
    }

    changeCookieStatus = () => {
        this.setState({showOpenCookie: !this.state.showOpenCookie})
    }

    componentDidMount() {
        sendData('', 'love tarot' , 'engaged');
    }
    
    render() {
    return (
        <div>
            <div component="p" style={{
                margin: '25px', color: '#e0515d', marginTop: '100px',
                fontSize: '45px', fontFamily: 'balthazar,serif',
                fontWeight: '300', letterSpacing: '.02em', textAlign: 'center'
            }}>
                <FormattedMessage id="dailylove.title"
                    defaultMessage="Free Daily Love Tarot Reading"
                />
            </div>
            <div style={{ padding: '40px' }}>
                <h2 style={{
                    fontFamily: 'khand,sans-serif',
                    fontSize: '2rem',
                    fontWeight: '100',
                    letterSpacing: '.02em',
                    textTransform: 'uppercase', textAlign: 'center'
                }}><FormattedMessage id="t21"
                    defaultMessage="THE DEVIL:"
                    />
                </h2>
                <img src={card2} style={{ marginLeft: '9%', float: 'left', padding: '20px' }} />

                <p style={{
                    fontSize: '2rem', color: '#fefefe',
                    fontFamily: 'balthazar,serif', marginLeft: '20%', marginRight: '20%', fontWeight: '400'
                }}>
                    <br></br>
                    <FormattedMessage id="t22"
                        defaultMessage="Are you having a hard time letting go of an unhealthy relationship? The Devil represents the tendency to cling to things that aren't good for you, and as long as you have this mindset, it will be hard for you to move forward. Once you understand that the chains of selfishness, materialism, obsession, etc., are holding you down, you can finally free yourself fromthe weight of them."
                    />
                    <br></br><br></br>
                </p>
            </div>
            <div style={{ display: 'flex', paddingBottom: '50px' }}>
                <span style={{ width: '33%' }}>
                </span>
                <span style={{ width: '33%' }}>
                    <Link to="/dailyLove">
                        <button style={{ lineHeight: '2', letterSpacing: '0.02em' }} className={'btn btn-danger btn-lg'}><strong><FormattedMessage id="pickano"
                            defaultMessage="PICK ANOTHER CARD"
                        /></strong></button>
                    </Link>
                </span>
                <span style={{ width: '34%' }}>
                </span>
            </div>
                        
        </div>
        )
    }
}

export default Card2;


// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/tarotCards/tarotCard2.js